import { selectProperBillingProfileFromPlace } from "./placeUtils";

export function billingProfileHasValidMHData(billingProfile) {
  return billingProfile?.MH_User?.FileEB?.idFile;
}

export function getUserIdForBillReceiver(placeData) {
  const billingProfileToGetReceiver =
    selectProperBillingProfileFromPlace(placeData);
  const userId =
    billingProfileToGetReceiver?.FK_User || placeData.Company.FK_User;
  return userId;
}
